import { useState } from "react";
import { FiMusic, FiCamera, FiExternalLink, FiDisc, FiVideo } from "react-icons/fi";
import palmsPlane from "../assets/journal/palms-plane.webp";
import neonPalm from "../assets/journal/neon-palm.webp";
import doomMask from "../assets/journal/doom-mask.webp";
import reaperPattern from "../assets/journal/reaper-pattern.webp";
import javascriptBird from "../assets/journal/javascript-bird.webp";
import beeSign from "../assets/journal/bee-sign.webp";
import ferns from "../assets/journal/ferns.webp";
import mountainMuseum from "../assets/journal/mountain-museum.webp";
import towerPalms from "../assets/journal/tower-palms.webp";
import cliffEdge from "../assets/journal/cliff-edge.webp";
import brownTee from "../assets/journal/brown-tee.webp";
import cannabisPlant from "../assets/journal/cannabis-plant.webp";
import thePacific from "../assets/journal/the-pacific.webp";
import palmFronds from "../assets/journal/palm-fronds.webp";
import safari911 from "../assets/journal/safari-911.webp";
import smileySticker from "../assets/journal/smiley-sticker.webp";
import staticBg from "../assets/journal/static-bg.mp4";
import "./Bliss.css";

const entries = [
  {
    id: 1,
    type: "song",
    title: "Franklin's Tower",
    artist: "Grateful Dead",
    note: "Roll away the dew. The jam that never lands the same way twice — pure sunshine in a song.",
    albumGradient: "linear-gradient(135deg, #0A0A0A 0%, #1a0800 50%, #E8450E 100%)",
    listenUrl: "#",
    date: "Mar 1, 2026",
  },
  {
    id: 2,
    type: "photo",
    photo: palmsPlane,
    caption: "Look up long enough and something always flies through.",
    date: "Feb 27, 2026",
  },
  {
    id: 3,
    type: "song",
    title: "Garden Grove",
    artist: "Sublime",
    note: "That opening riff is instant golden hour. Southern California in audio form.",
    albumGradient: "linear-gradient(135deg, #0A0A0A 0%, #180600 50%, #B83500 100%)",
    listenUrl: "#",
    date: "Feb 24, 2026",
  },
  {
    id: 4,
    type: "photo",
    photo: neonPalm,
    caption: "Neon palm burning red in a dark room. Instant vacation.",
    date: "Feb 21, 2026",
  },
  {
    id: 5,
    type: "photo",
    photo: doomMask,
    caption: "Stone-dipped villain mask on marble. ALL CAPS when you spell the man's name.",
    date: "Feb 19, 2026",
  },
  {
    id: 6,
    type: "song",
    title: "In McDonalds",
    artist: "Burial",
    note: "Two minutes of ghost-static melancholy. Nobody makes loneliness sound this beautiful.",
    albumGradient: "linear-gradient(135deg, #0A0A0A 0%, #1a0a02 50%, #FF5722 100%)",
    listenUrl: "#",
    date: "Feb 17, 2026",
  },
  {
    id: 7,
    type: "photo",
    photo: reaperPattern,
    caption: "Reaper repeat — flash-sheet energy as wallpaper.",
    date: "Feb 14, 2026",
  },
  {
    id: 8,
    type: "song",
    title: "Guy Goodwin",
    artist: "Pachyman",
    note: "Analog dub straight from the basement — tape hiss, space echo, and endless groove.",
    albumGradient: "linear-gradient(135deg, #0A0A0A 0%, #1c0c04 50%, #D63A00 100%)",
    listenUrl: "#",
    date: "Feb 8, 2026",
  },
  {
    id: 9,
    type: "photo",
    photo: javascriptBird,
    caption: "Dead bird, living language. Greatest logo mashup on the internet.",
    date: "Feb 5, 2026",
  },
  {
    id: 10,
    type: "photo",
    photo: beeSign,
    caption: "Bee crossing. Best road sign I've ever seen.",
    date: "Feb 1, 2026",
  },
  {
    id: 11,
    type: "song",
    title: "Keep It Cool",
    artist: "parkbreezy",
    note: "Smooth as it gets. This one lives on the late-drive playlist.",
    albumGradient: "linear-gradient(135deg, #0A0A0A 0%, #171006 50%, #E85D0E 100%)",
    listenUrl: "#",
    date: "Jan 29, 2026",
  },
  {
    id: 12,
    type: "photo",
    photo: ferns,
    caption: "Fern density study. Nature's pattern library.",
    date: "Jan 26, 2026",
  },
  {
    id: 13,
    type: "song",
    title: "The No. 4",
    artist: "Khruangbin",
    note: "Bass, reverb, restraint. Three instruments saying more than most bands manage with thirty.",
    albumGradient: "linear-gradient(135deg, #0A0A0A 0%, #150a03 50%, #F26522 100%)",
    listenUrl: "#",
    date: "Jan 22, 2026",
  },
  {
    id: 14,
    type: "photo",
    photo: mountainMuseum,
    caption: "Concrete spaceship parked on a ridge, lost in the fog.",
    date: "Jan 19, 2026",
  },
  {
    id: 15,
    type: "song",
    title: "Glue",
    artist: "Bicep",
    note: "The comedown anthem. Melancholy and euphoria sharing the same four bars.",
    albumGradient: "linear-gradient(135deg, #0A0A0A 0%, #120b04 50%, #FF5A1F 100%)",
    listenUrl: "#",
    date: "Jan 15, 2026",
  },
  {
    id: 16,
    type: "photo",
    photo: towerPalms,
    caption: "Terracotta, whitewash, and palms fighting for the sky.",
    date: "Jan 11, 2026",
  },
  {
    id: 17,
    type: "photo",
    photo: cliffEdge,
    caption: "Sandals at the edge. Don't look down — okay, look down.",
    date: "Jan 8, 2026",
  },
  {
    id: 18,
    type: "photo",
    photo: brownTee,
    caption: "Pixel eye tee — merch experiments in brown and orange.",
    date: "Jan 5, 2026",
  },
  {
    id: 19,
    type: "photo",
    photo: cannabisPlant,
    caption: "Studio portrait of the plant that built an industry.",
    date: "Jan 2, 2026",
  },
  {
    id: 20,
    type: "photo",
    video: staticBg,
    caption: "Static study — dither in motion.",
    date: "Dec 29, 2025",
  },
  {
    id: 21,
    type: "photo",
    photo: thePacific,
    caption: "The Pacific doing what it does.",
    date: "Dec 22, 2025",
  },
  {
    id: 22,
    type: "photo",
    photo: palmFronds,
    caption: "Palm fronds stacked like brushstrokes.",
    date: "Dec 18, 2025",
  },
  {
    id: 23,
    type: "photo",
    photo: safari911,
    caption: "Safari-spec 911 in hazard yellow. Lifted, flared, correct.",
    date: "Dec 15, 2025",
  },
  {
    id: 24,
    type: "photo",
    photo: smileySticker,
    caption: "Acid smiley on vinyl. Sticker season.",
    date: "Dec 11, 2025",
  },
];

function SongCard({ entry, index }) {
  return (
    <article
      className="bliss-card bliss-card--song"
      style={{ animationDelay: `${index * 0.08}s` }}
    >
      <div className="bliss-card__album" style={{ background: entry.albumGradient }}>
        <div className="bliss-card__album-icon">
          <FiDisc />
        </div>
        <div className="bliss-card__album-noise" />
        <div className="bliss-card__song-overlay">
          <div className="bliss-card__meta-badges">
            <span className="bliss-card__type-badge bliss-card__type-badge--song">
              <FiMusic size={10} />
              Song
            </span>
            <a href={entry.listenUrl} className="bliss-card__listen" target="_blank" rel="noopener noreferrer">
              Listen <FiExternalLink size={11} />
            </a>
          </div>
          <h3 className="bliss-card__title">{entry.title}</h3>
          <p className="bliss-card__artist">{entry.artist}</p>
        </div>
      </div>
    </article>
  );
}

function PhotoCard({ entry, index }) {
  return (
    <article
      className="bliss-card bliss-card--photo"
      style={{ animationDelay: `${index * 0.08}s` }}
    >
      {entry.video ? (
        <video
          src={entry.video}
          className="bliss-card__photo-img"
          autoPlay
          muted
          loop
          playsInline
        />
      ) : entry.photo ? (
        <img
          src={entry.photo}
          alt={entry.caption}
          className="bliss-card__photo-img"
          loading="lazy"
        />
      ) : (
        <div
          className="bliss-card__photo"
          style={{
            background: entry.photoGradient,
            aspectRatio: entry.aspectRatio,
          }}
        >
          <div className="bliss-card__photo-noise" />
          <div className="bliss-card__photo-icon">
            <FiCamera size={20} />
          </div>
        </div>
      )}
      <span className="bliss-card__type-badge bliss-card__type-badge--photo bliss-card__badge--overlay">
        {entry.video ? <FiVideo size={10} /> : <FiCamera size={10} />}
        {entry.video ? "Motion" : "Photo"}
      </span>
    </article>
  );
}

function Bliss() {
  const [filter, setFilter] = useState("all");

  const filtered = filter === "all"
    ? entries
    : entries.filter((e) => e.type === filter);

  return (
    <main className="bliss">
      <div className="bliss__grain" />

      <section className="bliss__header">
        <div className="bliss__header-label">Journal</div>
        <h1 className="bliss__title">
          Songs & <br />
          Photographs
        </h1>
        <p className="bliss__subtitle">
          A running collage of songs and images.
        </p>
      </section>

      <nav className="bliss__filters">
        <button
          className={`bliss__filter ${filter === "all" ? "bliss__filter--active" : ""}`}
          onClick={() => setFilter("all")}
        >
          All
        </button>
        <button
          className={`bliss__filter ${filter === "song" ? "bliss__filter--active" : ""}`}
          onClick={() => setFilter("song")}
        >
          <FiMusic size={12} />
          Songs
        </button>
        <button
          className={`bliss__filter ${filter === "photo" ? "bliss__filter--active" : ""}`}
          onClick={() => setFilter("photo")}
        >
          <FiCamera size={12} />
          Photos
        </button>
        <div className="bliss__filter-count">{filtered.length} entries</div>
      </nav>

      <div className="bliss__grid" key={filter}>
        {filtered.map((entry, i) =>
          entry.type === "song" ? (
            <SongCard key={entry.id} entry={entry} index={i} />
          ) : (
            <PhotoCard key={entry.id} entry={entry} index={i} />
          )
        )}
      </div>

      <footer className="bliss__footer">
        <div className="bliss__footer-line" />
        <p className="bliss__footer-text">More entries coming soon</p>
      </footer>
    </main>
  );
}

export default Bliss;
